<template>
    <div class="form-container">
        <div class="check-phone-header">
            重置密码
        </div>
        <div class="check-phone-tips">
            <p>修改{{ info.name }}({{ info.account }})的密码</p>
        </div>
        <div class="modifypwd-wrap">
            <div class="wrap-cell">
                <p>新密码</p>
                <div class="input-border">
                    <v-input
                        v-model="newPassword"
                        :class="{ 'input-error': !pwdValidate }"
                        @focus="onFocus"
                        placeholder="请输入新密码"
                        password
                    />
                </div>
                <div class="tips">
                    密码长度须6-16位，且包含以下情况的3种：大写字母、小写字母、数字、符号&、*、%等
                </div>
                <div :class="pwdValidate ? 'error-tip-hidden' : 'error-tip-show'">
                    {{ pwdFormatErrorMsg }}
                </div>
            </div>

            <div class="wrap-cell wrap-cell-large">
                <div>
                    <p>确认密码</p>
                    <div class="input-border">
                        <v-input
                            v-model="repeatPassword"
                            placeholder="请再次输入新密码"
                            password
                        />
                    </div>
                </div>
            </div>
            <div
                class="wrap-cell"
                style="text-align: center"
            >
                <v-button
                    v-if="showLastStep"
                    @click="lastStep"
                    status="primary"
                    class="next-step-btn"
                >
                    上一步
                </v-button>
                <v-button
                    :loading="resetLoading"
                    @click="passwordValidate"
                    status="primary"
                    class="next-step-btn"
                >
                    重置密码
                </v-button>
            </div>
        </div>

        <v-dialog
            v-model="resetSuccess"
            @confirm="resetSuccessConfirm"
            @close="resetSuccessConfirm"
            title="新密码设置成功"
            kind="alert"
            status="success"
        />
    </div>
</template>
<script>
import md5 from '@/utils/md5.js';
import { ajax } from '@tencent/qd-lib';

const RES_PWD_URL = '/v1/basic.account.account_web.Account/UpdatePsw';
export default {
    name: 'ResetPassWord',
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
        showLastStep: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            newPassword: '',
            repeatPassword: '',
            pwdValidate: true, // true 通过
            pwdFormatErrorMsg: '密码最大长度为16位',
            pwdErrorMsgMap: {
                0: '密码不能为空',
                1: '密码不能小于6位',
                2: '密码超出最大长度',
                3: '输入不符合强度要求',
                4: '两次密码输入不同',
                5: '重置密码失败',
            },
            resetSuccess: false,
            resetLoading: false,
        };
    },
    created() {
        // console.log('reset', this.info);
    },
    methods: {
        onFocus() {
            this.pwdValidate = true;
        },
        passwordValidate() {
            const value = this.newPassword.trim();
            const { pwdErrorMsgMap } = this;
            if (value === '') {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['0'];
                this.pwdValidate = false;
            } else if (value.length < 6) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['1'];
                this.pwdValidate = false;
            } else if (value.length > 16) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['2'];
                this.pwdValidate = false;
            } else if (
                !/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).+|(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).+|(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).+|(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).+)$/.test(value)
            ) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['3'];
                this.pwdValidate = false;
            } else if (value !== this.repeatPassword) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['4'];
                this.pwdValidate = false;
            } else {
                this.pwdValidate = true;
                this.resetPassWord();
            }
        },
        resetPassWord() {
            this.resetLoading = true;
            const params = {
                mobile: this.info.phoneNumber,
                sms_code: this.info.verifyCode,
                aid: this.info.aid,
                password: md5(this.repeatPassword),
            };
            ajax.gatewayPost(RES_PWD_URL, params).then((res) => {
                if (res && res.code === 0) {
                    // 重置成功的面板
                    this.resetLoading = false;
                    this.resetSuccess = true;
                } else {
                    this.resetLoading = false;
                    this.$message.warning(res.message);
                }
            })
                .catch((err) => {
                    this.resetLoading = false;
                    this.$message.warning(err.message);
                });
        },
        lastStep() {
            this.$emit('reback');
        },
        resetSuccessConfirm() {
            // 跳转到登录按钮
            window.open(`https://${window.location.hostname}/ac/login`, '_self');
        },
    },
};
</script>
<style lang="less" scoped>
@import '../style.less';
.modifypwd-wrap {
    .wrap-cell {
        text-align: unset;
        .input-border {
            width: 340px;
        }
        .tips {
            margin-left: 55px;
        }
        .next-step-btn {
            margin: 40px 10px 45px;
        }
    }
    .wrap-cell-large {
        margin-left: 56px;
        p {
            width: 56px;
            text-align: left;
        }
    }
}
</style>
